import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";

export const noWhitespaceValidator: ValidatorFn = (control: AbstractControl) => {
  if (!control.value) {
    return null; 
  }
  const isWhitespace = (control.value || '').trim().length === 0;
  return isWhitespace ? { whitespace: true } : null;
};

export const fileUploadForm = () => new FormGroup({
    customerID: new FormControl(null),
    typeID: new FormControl(null, Validators.required),
    document: new FormControl(null),
    documentID: new FormControl(null),
    quoteID: new FormControl(null),
    documentPath: new FormControl(null),
    documentName: new FormControl(null),
    documentType: new FormControl(null),
    type: new FormControl(null) 
});